import React, { FunctionComponent, useContext, useState } from 'react';
import { Button, Container, Typography } from '@mui/material';
import { SectionType } from '../../enums/SectionType';
import { AppContext } from '../../providers/AppContext';
import Board from '../../components/Board';
import Component from '../../components/Component';
import Banner from '../../components/Banner';
import EmojiEvents from '@mui/icons-material/EmojiEvents';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Construction from '@mui/icons-material/Construction';
import Whatshot from '@mui/icons-material/Whatshot';
import ShowChart from '@mui/icons-material/ShowChart';
import Comment from '@mui/icons-material/Comment';
import MyContainer from '../../components/MyContainer';
import GeneralInfo from '../sections/GeneralInfo';
import AboutMe from '../sections/AboutMe';
import LanguagesAndTools from '../sections/LanguagesAndTools';
import GitHubStreak from '../sections/GitHubStreak';
import GitHubStats from '../sections/GitHubStats';
import GitHubTrophy from '../sections/GitHubTrophy';
import Section from '../../interfaces/Section';
import ConnectWithMe from '../sections/ConnectWithMe';
import { StickyContainer, Sticky } from 'react-sticky';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../providers/ThemeContext';
import useWindowDimensions from '../../hooks/dimension';

interface HomeProps {

}

const Home: FunctionComponent<HomeProps> = () => {

    const appContext = useContext(AppContext);
    const { sections, username } = appContext;

    const { darkMode } = React.useContext(ThemeContext);

    const [dragId, setDragId] = useState<number>(0);
    const navigate = useNavigate();
    const { height, width } = useWindowDimensions();

    const onGenerate = () => {
        navigate('/preview')
    }

    const onAddSection = (section: Section) => {

        const newSections = sections;

        newSections.push(section);
        appContext.changeData({
            sections: newSections
        })
    }

    const onChangeOrder = (sections: Section[]) => {
        appContext.changeData({
            sections
        })
    }

    const onMoveSection = (orderId: number, operan: number) => {

        const newElements = sections.map((element: Section) => {

            if (element.order === Number(orderId - operan)) {
                element.order = orderId;
            } else if (element.order === orderId) {
                element.order = orderId - operan;
            }

            return element;
        });

        onChangeOrder(newElements);
    }

    const onRemoveSection = (id: number) => {
        let newElements = sections.filter((element: Section) => element.order !== id);
        newElements = newElements.map((element: Section, index: number) => {
            element.order = index;
            return element;
        });
        onChangeOrder(newElements);
    }

    const drop = (e: any, isOrder?: boolean) => {

        e.preventDefault();

        const cardId = e.dataTransfer.getData('cardId');

        let isExist = false;
        sections.forEach(item => {
            if (item.name === cardId) {
                isExist = true;
                return
            }
        })
        if (!isExist) {
            if (cardId === SectionType.ABOUT && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.ABOUT,
                    order: sections.length
                });
            } else if (cardId === SectionType.TROPHY && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.TROPHY,
                    order: sections.length
                });
            } else if (cardId === SectionType.STATS && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.STATS,
                    order: sections.length
                });
            } else if (cardId === SectionType.LNT && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.LNT,
                    order: sections.length
                });
            } else if (cardId === SectionType.STREAK && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.STREAK,
                    order: sections.length
                });
            } else if (cardId === SectionType.CONNECT && !isOrder) {
                onAddSection({
                    id: sections.length,
                    name: SectionType.CONNECT,
                    order: sections.length
                });
            } else {
                const dragElement = sections.find((item) => item.id === dragId);
                const dropElement = sections.find((item) => item.id === Number(e.currentTarget.id));

                const dragElementOrder = dragElement?.order;
                const dropElementOrder = dropElement?.order;

                if (dragElementOrder !== undefined && dropElementOrder !== undefined) {

                    const newElements = sections.map((element: Section) => {
                        if (element.id === dragId) {
                            element.order = dropElementOrder;
                        }
                        if (element.id === Number(e.currentTarget.id)) {
                            element.order = dragElementOrder;
                        }
                        return element;
                    });

                    onChangeOrder(newElements);
                }
            }
        }
    }

    const dragOver = (e: any) => {
        e.preventDefault();
    }

    const handleDrag = (ev: any) => {
        setDragId(Number(ev.currentTarget.id));
    };

    return (
        <div style={{ backgroundColor: darkMode ? 'black' : 'white' }}>
            <Banner />
            {width && width > 600 ? WebView(width, drop, dragOver, sections, onMoveSection, onRemoveSection, handleDrag, username, onGenerate, darkMode) : MobileView(width, drop, dragOver, sections, onMoveSection, onRemoveSection, handleDrag, username, onGenerate, darkMode)}
        </div>
    );
}

export default Home;

function WebView(width: number | null, drop: (e: any, isOrder?: boolean) => void, dragOver: (e: any) => void, sections: Section[], onMoveSection: (orderId: number, operan: number) => void, onRemoveSection: (id: number) => void, handleDrag: (ev: any) => void, username: string, onGenerate: () => void, darkMode: boolean) {
    return <Container>

        <div
            className='flexbox'
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-around'
            }}>
            <div
                onDrop={drop}
                onDragOver={dragOver}
                style={{
                    display: 'flex',
                    flex: 7,
                    flexDirection: 'column',
                    marginInlineEnd: 16,
                    padding: 16,
                    minHeight: '100vh'
                }}>

                <GeneralInfo handleDrag={() => { }} handleDrop={() => { }} id='GI' />

                {sections
                    .sort((a, b) => a.order - b.order)
                    .map((section, index) => {
                        return (
                            <MyContainer
                                id={section.order}
                                className='containers'
                                section={section}
                                onMoveSection={onMoveSection}
                                length={sections.length - 1}
                                onRemoveSection={onRemoveSection}
                            >
                                {/* section.name === SectionType.GI ? <GeneralInfo handleDrag={handleDrag} handleDrop={drop} id={section.id} /> : */}
                                {section.name === SectionType.TROPHY ? <GitHubTrophy handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                    section.name === SectionType.ABOUT ? <AboutMe handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                        section.name === SectionType.LNT ? <LanguagesAndTools handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                            section.name === SectionType.STREAK ? <GitHubStreak handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                                section.name === SectionType.CONNECT ? <ConnectWithMe handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                                    section.name === SectionType.STATS && <GitHubStats handleDrag={handleDrag} handleDrop={drop} id={section.id} />}
                            </MyContainer>
                        );
                    })}

                {(sections.length > 0) ? <Button disabled={username === ''} variant='outlined' onClick={onGenerate}>
                    Generate
                </Button> :
                    <Typography variant='body1'>
                        Drag and Drop to add section
                    </Typography>}

            </div>

            <StickyContainer style={{
                display: 'flex',
                flex: 2,
                flexDirection: 'column',
                marginTop: 8,
                height: 'auto',
                marginInlineStart: 24,
            }}>
                <Sticky topOffset={20} bottomOffset={80}>
                    {({ style }) => (
                        <div style={style}>
                            <Typography variant='h6' style={{
                                marginLeft: 16,
                                marginBottom: 8,
                                color: darkMode ? '#AAAAAA' : '#121212'
                            }}>
                                Add Section
                            </Typography>

                            <Board
                                id='board-1'
                                className='board'
                            >
                                <Component
                                    id={SectionType.TROPHY}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <EmojiEvents />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            GitHub Thropy
                                        </Typography>
                                    </div>
                                </Component>
                                <Component
                                    id={SectionType.ABOUT}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <AutoAwesome />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            About Me
                                        </Typography>
                                    </div>
                                </Component>
                                <Component
                                    id={SectionType.LNT}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <Construction />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            Languages and Tools
                                        </Typography>
                                    </div>
                                </Component>
                                <Component
                                    id={SectionType.STREAK}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <Whatshot />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            GitHub Streak
                                        </Typography>
                                    </div>
                                </Component>
                                <Component
                                    id={SectionType.STATS}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <ShowChart />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            GitHub Stats
                                        </Typography>
                                    </div>
                                </Component>
                                <Component
                                    id={SectionType.CONNECT}
                                    className='card'
                                    draggable={true}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    }}>
                                        <Comment />
                                        <Typography variant='subtitle2' style={{
                                            marginLeft: 16,
                                        }}>
                                            Connect with Me
                                        </Typography>
                                    </div>
                                </Component>
                            </Board>
                        </div>
                    )}

                </Sticky>
            </StickyContainer>
        </div>
    </Container>;
}

function MobileView(width: number | null, drop: (e: any, isOrder?: boolean) => void, dragOver: (e: any) => void, sections: Section[], onMoveSection: (orderId: number, operan: number) => void, onRemoveSection: (id: number) => void, handleDrag: (ev: any) => void, username: string, onGenerate: () => void, darkMode: boolean) {
    return <Container>

        <div
            className='flexbox'
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-around'
            }}>
            <div
                onDrop={drop}
                onDragOver={dragOver}
                style={{
                    display: 'flex',
                    flex: 7,
                    flexDirection: 'column',
                    padding: 15,
                    minHeight: '100vh'
                }}>

                <GeneralInfo handleDrag={() => { }} handleDrop={() => { }} id='GI' />

                {sections
                    .sort((a, b) => a.order - b.order)
                    .map((section, index) => {
                        return (
                            <MyContainer
                                id={section.order}
                                className='containers'
                                section={section}
                                onMoveSection={onMoveSection}
                                length={sections.length - 1}
                                onRemoveSection={onRemoveSection}
                            >
                                {/* section.name === SectionType.GI ? <GeneralInfo handleDrag={handleDrag} handleDrop={drop} id={section.id} /> : */}
                                {section.name === SectionType.TROPHY ? <GitHubTrophy handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                    section.name === SectionType.ABOUT ? <AboutMe handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                        section.name === SectionType.LNT ? <LanguagesAndTools handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :  
                                            section.name === SectionType.STREAK ? <GitHubStreak handleDrag={handleDrag} handleDrop={drop} id={section.id} /> : 
                                                section.name === SectionType.CONNECT ? <ConnectWithMe handleDrag={handleDrag} handleDrop={drop} id={section.id} /> :
                                                    section.name === SectionType.STATS && <GitHubStats handleDrag={handleDrag} handleDrop={drop} id={section.id} />
                                                    }
                            </MyContainer>
                        );
                    })}

                {(sections.length > 0) ? <Button disabled={username === ''} variant='outlined' onClick={onGenerate}>
                    Generate
                </Button> :
                    <Typography variant='body1'>
                        Drag and Drop to add section
                    </Typography>}

            </div>

            
        </div>
    </Container>;
}
